var map = {
	"./babys.svg": "1d6c",
	"./bag.svg": "2584",
	"./bazaar.svg": "9996",
	"./bike.svg": "2ccd",
	"./bowling.svg": "d4bf",
	"./bulb.svg": "1646",
	"./bus.svg": "45c6",
	"./crossroad.svg": "81ba",
	"./dad_01.svg": "69f6",
	"./dad_02.svg": "1036",
	"./deaf.svg": "e6ec",
	"./diet.svg": "84ab",
	"./doctor.svg": "6b17",
	"./ecology.svg": "82ad",
	"./exhibition.svg": "9cbd",
	"./family.svg": "e906",
	"./forest.svg": "b84d",
	"./hand.svg": "e7ce",
	"./home.svg": "e6bb",
	"./home_2.svg": "03f8",
	"./juice.svg": "ed52",
	"./kindergarten.svg": "29c8",
	"./kita.svg": "7069",
	"./lebenslagen.svg": "2181",
	"./lotus.svg": "4e59",
	"./luggage_2.svg": "f533",
	"./map.svg": "972a",
	"./meeting.svg": "94c4",
	"./mic.svg": "f541",
	"./online.svg": "0ea0",
	"./partnerschaft.svg": "fbb5",
	"./rope.svg": "2963",
	"./ruler.svg": "35ef",
	"./scale.svg": "10c4",
	"./schwangerschaft.svg": "732c",
	"./seniors.svg": "6772",
	"./signing.svg": "9451",
	"./soccer.svg": "5077",
	"./stretch.svg": "0cc8",
	"./stroller.svg": "601a",
	"./tea.svg": "e437",
	"./teddy.svg": "d908",
	"./teenies.svg": "18bd",
	"./tipi.svg": "9250",
	"./wheelchair.svg": "a4dc",
	"./yoga.svg": "2fe4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5216";